<template>
  <div class="posterImg" v-if="lockPoster">
    <div>
      <img :src="mobilePosterImg" alt="" />
      <p class="posterDown">{{ language === 1 ? mobileTipEn : mobileTip }}</p>
    </div>
    <div class="close" @click="closePoster">×</div>
  </div>
</template>

<script>
export default {
  name: 'mobilePosterImg',
  props: {
    mobilePosterImg: String,
    language: {
      default: 0
    }
  },
  data() {
    return {
      lockPoster: false,
      mobileTip: '长按上方图片，将海报保存到本地',
      mobileTipEn: 'Long press the image to download it.'
    }
  },
  methods: {
    closePoster(e) {
      e.stopPropagation()
      this.lockPoster = false
    }
  }
}
</script>

<style lang="scss" scoped>
.posterImg {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 90000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, 0.85);
  img {
    width: 100%;
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #fff;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 30px;
  }
  .posterDown {
    margin: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 14px;
    margin-top: 20px;
  }
}
</style>
